import React from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from 'react-router-dom';
import PermissionType from '../config/types/PermissionType';
import Loading from '../components/Loading';
import { usePermission } from '../hooks/permission';
import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  permission?: PermissionType;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  permission,
  component: Component,
  ...rest
}) => {
  const { user, loading: loadingAuth } = useAuth();
  const { hasPermission } = usePermission();
  const token = localStorage.getItem('@Cinco:token');

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (loadingAuth && token) {
          return <Loading />;
        }

        if (isPrivate === !!user) {
          if (permission && !hasPermission(permission)) {
            return (
              <Redirect
                to={{
                  pathname: '/error',
                  state: { from: location },
                }}
              />
            );
          }

          return <Component />;
        }

        return (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/dashboard/profile',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
